var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-org',{attrs:{"label":_vm.label,"type":"Insurer","required":_vm.required,"placeholder":_vm.placeholder,"help-text":_vm.helpText,"no-form":_vm.noForm,"value-key":"value","size":_vm.size,"disabled":_vm.disabled},on:{"change":_vm.updated},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }